import TextCreate from 'core/display/simple/Text'
import { signal } from 'services/SignalsService'

export default class FreespinsCountText extends TextCreate{
  constructor(data) {
    super(data)

    this.freespinModel = game.models.FreespinModel.get()

    signal.on('STATE:IN:SPIN', this.spin.bind(this))
    signal.on('STATE:IN:FS-ADD', this.update.bind(this))
    signal.on('STATE:IN:FS-START', this.update.bind(this))
    signal.once('INIT:FREESPINS', this.update.bind(this))
  }

  spin() {
    super.update(this.freespinModel.left - 1 || '')
  }

  update() {
    super.update(this.freespinModel.left || '')
  }
}
